module.exports = __webpack_public_path__ + "static/media/stack-empty.a7054edd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/stack-empty.svg
// module id = 3569
// module chunks = 7